module.exports = __webpack_public_path__ + "static/img/default_person.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/default_person.png
// module id = 547
// module chunks = 0